import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContainerComponent } from '../../../shared/components/container/container.component';
import { GlobalButtonComponent } from '../../../shared/components/global-button/global-button.component';

@Component({
  selector: '[information]',
  imports: [ContainerComponent, GlobalButtonComponent],
  templateUrl: './information.html',
  styleUrl: './information.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'text-dark',
    id: 'how-to-screen'
  }
})
export class Information { 
  cardButton = {
    buttonLabel: 'Download',
    buttonUrl: '/assets/pdf/interpreting-type-1-diabetes-screening-results.pdf',
    openInNewTab: true,
    buttonIcon: 'download-icon'
  };
  cardButtonMobile = {
    buttonLabel: 'Download',
    buttonUrl: '/assets/pdf/interpreting-type-1-diabetes-screening-results-mobile.pdf',
    openInNewTab: true,
    buttonIcon: 'download-icon'
  };
}
